import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from './PlumPlusDash/Footer';

const LegalLayout = ({ children, title, lastUpdated }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Back button */}
      <div className="fixed top-6 left-6 z-50">
        <button
          onClick={() => navigate('/')}
          className="group flex items-center space-x-2 bg-white px-4 py-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-5 w-5 text-primary group-hover:-translate-x-0.5 transition-transform duration-300" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          <span className="text-gray-600 font-medium">Retour</span>
        </button>
      </div>

      {/* Main content */}
      <main className="flex-grow pt-20 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-primary to-primary/90 px-6 py-8 sm:px-10">
              <h1 className="text-3xl font-bold text-white">
                {title}
              </h1>
              {lastUpdated && (
                <p className="text-white/80 text-sm mt-2">
                  Dernière mise à jour : {lastUpdated}
                </p>
              )}
            </div>

            {/* Content */}
            <div className="p-6 sm:p-10">
              {children}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default LegalLayout; 